export default {"src":"/_next/static/media/broken-image.38d15dfb.svg","height":199,"width":173,"blurWidth":0,"blurHeight":0};